export default __webpack_public_path__ + "static/media/bitcoin pc done.e13784af.png";